export default {"src":"/polygon/_next/static/media/tokenImage.23fcc4cc.svg","height":80,"width":81};